import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/vendor-actions';
import { VendorActions } from '../constants';
import { IVendor } from 'src/types/vendor';

export interface VendorState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IVendor>;
    current: IVendor | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function vendors(state: VendorState = initialState, action: Actions | any): VendorState {
    switch (action.type) {
        case requestType(VendorActions.PERSIST_VENDOR):
            return { ...state, error: '', inProgress: true };
        case successType(VendorActions.PERSIST_VENDOR):
            return { ...state, inProgress: false };
        case failureType(VendorActions.PERSIST_VENDOR):
            return { ...state, error: action.error, inProgress: false };

        case requestType(VendorActions.FETCH_VENDORS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(VendorActions.FETCH_VENDORS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(VendorActions.FETCH_VENDORS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(VendorActions.FETCH_VENDORS_SIMPLY):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(VendorActions.FETCH_VENDORS_SIMPLY):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(VendorActions.FETCH_VENDORS_SIMPLY):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(VendorActions.FETCH_VENDOR):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(VendorActions.FETCH_VENDOR):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(VendorActions.FETCH_VENDOR):
            return { ...state, inProgress: false, error: action.error };
        case requestType(VendorActions.DELETE_VENDOR):
            return { ...state, error: '', inProgress: true };
        case successType(VendorActions.DELETE_VENDOR):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IVendor) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(VendorActions.DELETE_VENDOR):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        case requestType(VendorActions.FETCH_FILES_VENDOR):
            return { ...state, error: '', inProgress: true };
        case successType(VendorActions.FETCH_FILES_VENDOR):
            return { ...state, inProgress: false, currentFiles: action.payload };
        case failureType(VendorActions.FETCH_FILES_VENDOR):
            return { ...state, inProgress: false, error: action.error };
        case requestType(VendorActions.DELETE_FILE_VENDOR):
            return { ...state, error: '', inProgress: true };
        case successType(VendorActions.DELETE_FILE_VENDOR):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                inProgress: false,
                currentFiles: curNewFiles,
            };
        case failureType(VendorActions.DELETE_FILE_VENDOR):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case successType(VendorActions.CREATE_FILES_VENDOR):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                inProgress: false,
                currentFiles: curFiles,
            };
        case requestType(VendorActions.CREATE_FILES_VENDOR):
            return { ...state, error: '', inProgress: true };
        case failureType(VendorActions.CREATE_FILES_VENDOR):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        default:
            return state;
    }
}
